import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@banyan/commons/guards/auth/auth.guard';
import { adminGuard } from '@banyan/modules/admin/guard/admin.guard';
import { articleResolver } from '@banyan/modules/articles/article.resolver';
import { ArticleComponent } from '@banyan/modules/articles/components/article.component';
import { FragranceCatalogComponent } from '@banyan/modules/catalog/components/fragrance-catalog/fragrance-catalog.component';
import { FragranceCatalogProductComponent } from '@banyan/modules/catalog/components/fragrance-catalog-product/fragrance-catalog-product.component';
import { EditoComponent } from '@banyan/modules/edito/component/edito.component';
import { editoResolver } from '@banyan/modules/edito/edito.resolver';
import { FAQComponent } from '@banyan/modules/faq/components/faq.component';
import {
  TrendsInspirationsComponent
} from '@banyan/modules/trends-inspirations/components/trends-inspirations.component';
import { aboutResolver } from '@banyan/modules/who-we-are/about.resolver';
import { WhoWeAreComponent } from '@banyan/modules/who-we-are/components/who-we-are.component';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'home',
    loadChildren: () =>
      import('@banyan/modules/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    title: 'register',
    loadChildren: () =>
      import('./modules/register/register.module').then(
        m => m.RegistrationModule,
      ),
  },
  {
    path: 'contact',
    title: 'contact',
    loadChildren: () =>
      import('./modules/contact/contact.module').then(m => m.ContactModule),
  },
  {
    path: 'terms-of-use',
    title: 'terms',
    loadChildren: () =>
      import('./modules/terms-of-use/terms-of-use.module').then(
        m => m.TermsOfUseModule,
      ),
  },
  {
    path: 'who-we-are',
    title: 'who-we-are',
    component: WhoWeAreComponent,
    resolve: {
      about: aboutResolver
    }
  },
  {
    path: 'trends-inspirations',
    title: 'trends-inspirations',
    component: TrendsInspirationsComponent,
  },
  {
    path: 'faq',
    title: 'faq',
    component: FAQComponent,
  },
  {
    path: 'cookie-policy',
    title: 'cookie-policy',
    loadChildren: () =>
      import('./modules/cookie-policy/cookie-policy.module').then(
        m => m.CookiePolicyModule,
      ),
  },
  {
    path: 'edito/:id',
    component: EditoComponent,
    resolve: {
      edito: editoResolver,
    },
  },
  {
    path: 'articles/:id',
    component: ArticleComponent,
    resolve: {
      article: articleResolver,
    },
  },
  {
    path: 'protected',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'capture-needs',
        pathMatch: 'full',
      },
      {
        path: 'capture-needs',
        title: 'capture-needs',
        loadChildren: () =>
          import('./modules/capture-needs/capture-needs.module').then(
            m => m.CaptureNeedsModule,
          ),
      },
      {
        path: 'profile',
        title: 'profile',
        loadChildren: () =>
          import('./modules/account/account.module').then(m => m.AccountModule),
      },
      {
        path: 'proposal',
        loadChildren: () =>
          import('@banyan/modules/request/quote.module').then(
            m => m.QuoteModule,
          ),
      },
      {
        path: 'cart',
        title: 'cart',
        loadChildren: () =>
          import('./modules/cart/cart.module').then(m => m.CartModule),
      },
      {
        path: 'orders',
        title: 'orders',
        loadChildren: () =>
          import('./modules/order/order.module').then(m => m.OrderModule),
      },
      {
        path: 'payment',
        title: 'payment',
        loadChildren: () =>
          import('./modules/payment/payment.module').then(m => m.PaymentModule),
      },
      {
        path: 'checkout',
        title: 'checkout',
        loadChildren: () =>
          import('./modules/checkout/checkout.module').then(m => m.CheckoutModule),
      },
      {
        path: 'fragrance-catalogue',
        title: 'fragrance-catalogue',
        component: FragranceCatalogComponent,
      },
      {
        path: 'fragrance-catalogue/:id',
        title: 'fragrance-catalogue',
        component: FragranceCatalogProductComponent,
      }
    ],
  },
  {
    path: 'unprotected',
    loadChildren: () =>
      import('./modules/shared/shared.module').then(m => m.SharedModule),
  },
  {
    path: 'error',
    title: 'error404',
    loadChildren: () =>
      import('./modules/standalone/c404/c404.module').then(m => m.C404Module),
  },
  {
    path: 'admin',
    title: 'admin',
    canActivate: [adminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./modules/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    QuicklinkModule,
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: QuicklinkStrategy
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
